export default {
    GET_COMPANY:(state)=>{
        return state.company
    },
}